/**
 * audienceParam — pure validation + serialization for audience definitions
 * (FEAT-ANALYTICS-002). Keeps the builder honest before it hits the API.
 */
import { getDim } from './dimensions';

export function validateCondition(c) {
  const d = c && getDim(c.dim);
  if (!d || !c.operator) return false;
  if (d.kind === 'event') return String(c.value || '').trim() !== '';
  if (d.kind === 'time') return Number(c.value) > 0;
  if (d.kind === 'numeric') {
    if (c.operator === 'between') return Array.isArray(c.value) && c.value.length === 2 && c.value.every((v) => v !== '' && v != null);
    return c.value !== '' && c.value != null;
  }
  if (c.operator === 'in' || c.operator === 'not_in') {
    const arr = Array.isArray(c.value) ? c.value : String(c.value || '').split(',').map((s) => s.trim()).filter(Boolean);
    return arr.length > 0;
  }
  return String(c.value ?? '').trim() !== '';
}

/** Normalize a builder draft → a clean, API-ready definition (drops invalid conditions). */
export function cleanDefinition({ matchMode = 'and', conditions = [] } = {}) {
  const valid = conditions.filter(validateCondition).map((c) => {
    const out = { ...c };
    if ((c.operator === 'in' || c.operator === 'not_in') && !Array.isArray(c.value)) {
      out.value = String(c.value || '').split(',').map((s) => s.trim()).filter(Boolean);
    }
    return out;
  });
  return { match: 'all', groups: valid.length ? [{ op: matchMode === 'or' ? 'or' : 'and', conditions: valid }] : [] };
}

export function hasValidConditions(draft) {
  return (draft.conditions || []).some(validateCondition);
}

/** Definition → compact URL param (for report ?audience=). */
export function toParam(def) {
  try { return encodeURIComponent(JSON.stringify(def)); } catch (_) { return ''; }
}
